import { api } from "./api";

/** Değer Kaybı Merkezi — KPI, kanban, öğrenme düzeltme (hesaplama motoruna dokunmaz). */
export const degerKaybiMerkez = {
    ozet: (params = {}) =>
        api.get("/v1/admin/deger-kaybi/ozet/", { params }).then((r) => r.data),

    ogrenmeDuzelt: (id, gercekDeger) =>
        api
            .post(`/v1/admin/deger-kaybi/${id}/ogrenme-duzelt/`, {
                gercek_deger: gercekDeger,
            })
            .then((r) => r.data),

    hesaplamayiTamamla: (id) =>
        api
            .post(`/v1/admin/deger-kaybi/${id}/hesaplamayi-tamamla/`)
            .then((r) => r.data),
};

export const DK_ASAMALARI = [
    { value: "HESAPLANMADI", label: "Hesaplanmadı" },
    { value: "BASVURU", label: "Başvuru" },
    { value: "TAHKIM", label: "Tahkim" },
    { value: "TAHSILAT", label: "Tahsilat" },
];
